const API_URL = '/subject'

export const state = () => ({
  subject: {},
  wasteEvidenceHeaders: {},
})

export const getters = {}

export const mutations = {
  SET_SUBJECT(state, subject) {
    state.subject = subject
  },
  REMOVE_SUBJECT(state) {
    state.subject = {}
  },
  SET_WASTE_EVIDENCE_HEADERS(state, wasteEvidenceHeaders) {
    state.wasteEvidenceHeaders = wasteEvidenceHeaders
  },
}

export const actions = {
  async fetch({ commit }, subject_id) {
    let { data: subject } = await useApi(`${API_URL}/${subject_id}`)

    commit('SET_SUBJECT', subject.value)

    return subject.value
  },
  async update({ commit }, { subject_id, subject }) {
    let { data } = await useApi(`${API_URL}/${subject_id}`, { method: 'put', body: subject })
    subject = data.value
    commit('SET_SUBJECT', subject)

    return subject
  },
  async delete({ commit }, { subject_id }) {
    await useApi(`${API_URL}/${subject_id}`, { method: 'delete' })

    commit('REMOVE_SUBJECT')
  },
  async fetchWasteEvidenceHeaders({ commit }, { subject_id, params }) {
    let { data: wasteEvidenceHeaders } = await useApi(`${API_URL}/${subject_id}/waste-evidence-header`, {
      query: params,
    })

    commit('SET_WASTE_EVIDENCE_HEADERS', wasteEvidenceHeaders.value)

    return wasteEvidenceHeaders.value
  },
}
